import { IMaskInput } from "react-imask";

const FormularioInput = (props) => {
  const temErro = Boolean(props.error);

  const isNative = props.type === "date" || props.type === "number";

  return (
    <div
      className={`form-group ${props.size} ${temErro ? "has-error" : ""}`}
      data-field={props.id}
    >
      <label htmlFor={props.id}>
        {props.title}{" "}
        <span className={props.required}>
          {props.required === "required" ? "*" : ""}
        </span>
      </label>

      {isNative ? (
        // ✅ Para date/number: input nativo (onChange funciona sempre)
        <input
          id={props.id}
          name={props.id}
          type={props.type}
          value={props.valor}
          placeholder={props.placeholder}
          required={props.required === "required"}
          className={temErro ? "input-error" : ""}
          disabled={props.disabled}
          readOnly={props.readOnly}
          onChange={(e) => props.aoAlterado(e.target.value)}
        />
      ) : (
        <IMaskInput
          id={props.id}
          name={props.id}
          type={props.type}
          mask={props.mask}
          value={props.valor}
          placeholder={props.placeholder}
          required={props.required === "required"}
          className={temErro ? "input-error" : ""}
          disabled={props.disabled}
          readOnly={props.readOnly}
          dispatch={props.dispatch}

          // ✅ continua usando máscara quando existir
          onAccept={(value) => props.aoAlterado(value)}

          // ✅ fallback: garante update mesmo sem mask / em alguns tipos
          onChange={(e) => props.aoAlterado(e?.target?.value)}
        />

      )}

      {temErro ? (
        <div className="error-text">{props.error}</div>
      ) : (
        <div className="helper">{props.helper}</div>
      )}
    </div>
  );
};

export default FormularioInput;
